import OpenGraph from 'components/OpenGraph'
import config from 'common/config'
import Link from 'components/Link'
import routes from 'common/routes'
import { FeedbackIcon } from 'cc/icons'
import { cn } from 'common/utils'

// TODO: make links pretty

const DEFAULT_CLASSES = 'text-gray-600 hover:text-gray-800'
const TocLink = ({ href, children }) => (
  <li>
    <Link href={href} className={DEFAULT_CLASSES}>
      {children}
    </Link>
  </li>
)

const AboutPage = (props) => (
  <>
    <OpenGraph
      title="About"
      // TODO:
      // description=""
    />
    <div className="text-gray-700">
      <div className="grid grid-cols-1 sm:grid-cols-2">
        <div className="">
          <h3 className="text-3xl mt-5 text-gray-800">For humans</h3>
          <ul className="list-disc list-inside my-3 space-y-2 text-xl">
            <TocLink href={routes.faqPath}>Frequently Asked Questions</TocLink>
            <TocLink href={routes.contactPath}>
              <FeedbackIcon className="mr-1 inline" /> Contact
            </TocLink>
          </ul>
        </div>
        <div className="">
          <h3 className="text-3xl mt-5 text-gray-800">Legalese</h3>
          <ul className="list-disc list-inside my-3 space-y-2 text-xl">
            <TocLink href={routes.privacyPolicyPath}>Privacy Policy</TocLink>
            <TocLink href={routes.termsOfServicePath}>Terms of Service</TocLink>
          </ul>
        </div>
      </div>
      <div className="h-screen flex flex-col justify-center items-center p-5">
        <Link
          href={routes.aboutExtensionPath}
          className={cn(DEFAULT_CLASSES, 'font-bold text-2xl pb-24')}
        >
          Download Extension
        </Link>
      </div>
    </div>
  </>
)

AboutPage.title = 'Links'

export default AboutPage
